import {HoursItemRes} from "types";
import {apiUrl} from "../config/api";
import {useContext, useState} from "react";
import {AuthContextUser} from "../auth/AuthContext";
import {toast} from "react-toastify";
import {EditHours} from "./AddHours/EditHours";

interface Props {
    hour: HoursItemRes;
    number: number;
    onHoursChange: () => void;
}

export const HoursTableRow = (props: Props) => {
    const [showEditModal, setShowEditModal] = useState(false);

    const deleteHour = async (e: React.MouseEvent<Element, MouseEvent>) => {
        e.preventDefault();

        console.log('Props hour object:', props.hour);
        console.log('Hour ID:', props.hour.id);
        console.log('All props.hour keys:', Object.keys(props.hour));

        // Sprawdzamy różne możliwe lokalizacje ID
        const hourId = props.hour.id || (props.hour as any).hourId || (props.hour as any)._id;
        
        if (!hourId) {
            console.error('Nie znaleziono ID w obiekcie hour:', props.hour);
            toast.error('Brak ID godziny - nie można usunąć. Sprawdź konsolę przeglądarki.');
            return;
        }

        if (!window.confirm(`Are you sure you want to remove hour:
         ${props.hour.projectId}  ${props.hour.employeeId} with date: ${props.hour.date}?`)) {
            return;
        }

        try {
            const res = await fetch(`${apiUrl}/hour/${hourId}`, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include',
            });

            if (!res.ok) {
                const errorText = await res.text();
                toast.error(`Błąd podczas usuwania: ${errorText || res.statusText}`);
                return;
            }

            toast.success('Godzina została usunięta');
            props.onHoursChange();
        } catch (error) {
            toast.error(`Błąd podczas usuwania godziny: ${error}`);
        }
    };

    const handleEdit = (e: React.MouseEvent<Element, MouseEvent>) => {
        e.preventDefault();
        setShowEditModal(true);
    };

    const { user } = useContext(AuthContextUser);

    return (
        <>
        <tr>
            <th>{props.number}</th>
                <td>
                    {props.hour.date}
                </td>
                <td>
                    {props.hour.quantity}
                </td>
                <td>
                    {props.hour.projectId}
                </td>
                <td>
                    {props.hour.kindofworkId}
                </td>
                 {user?.role === 'Boss' &&
                    <td>
                        {props.hour.employeeId}
                    </td>
                    }
                <td>
                    {/*<a href="#" onClick={handleEdit} style={{marginRight: '10px'}}>✏️</a>*/}
                    <a href="#" onClick={deleteHour}>🗑️</a>
                </td>
        </tr>
        
        <EditHours 
            show={showEditModal}
            onHide={() => setShowEditModal(false)}
            hourData={props.hour}
            onHoursChange={props.onHoursChange}
        />
        </>
    );
};